import React, { useEffect, useState } from 'react'

import {
  Upload, message, Button, Row, Col, Table, Spin, PageHeader, Divider,
} from 'antd'
import { UploadOutlined, DownloadOutlined } from '@ant-design/icons'

import { format } from 'date-fns'

import Cookies from 'js-cookie'

import { fetch, fetchDownload } from '../../utils/fetch'

const { Column } = Table

const endpoint = process.env[`REACT_APP_ENDPOINT_${process.env.REACT_APP_ENV}`]

const ArticleStandard = ({ name }) => {
  const [articleList, setArticleList] = useState([])
  const [isLoading, setIsLoading] = useState(false)

  useEffect(
    () => {
      getDataArticleStandard()
    },
    [],
  )

  const getDataArticleStandard = () => {
    setIsLoading(true)
    fetch({
      url: '/management/articleStandard',
    }).then((res) => {
      if (res.data?.success) {
        setArticleList(res.data?.data)
      }
      setIsLoading(false)
    })
  }

  const DownloadArticleStandard = () => {
    setIsLoading(true)
    fetchDownload({
      url: '/management/articleStandard/download',
      fileName: `articleStandard_${format(new Date(), 'dd-MM-yyyy')}.xlsx`,
    }).then((res) => {
      if (res.success) {
        message.success('Download Success')
      } else {
        message.error(res.message)
      }
    })
    setIsLoading(false)
  }

  const props = {
    name: 'file',
    action: `${endpoint}/management/articleStandard/upload`,
    accept: 'application/xlsx',
    headers: {
      authorization: Cookies.get(`oms-token-${process.env.REACT_APP_ENV}`),
    },
    onChange(info) {
      setIsLoading(true)
      if (info.file.status !== 'uploading') {
        console.log(info.file, info.fileList)
        setIsLoading(false)
      }
      if (info.file.status === 'done') {
        message.success(`${info.file.name} file uploaded successfully`)
        getDataArticleStandard()
        setIsLoading(false)
      } else if (info.file.status === 'error') {
        message.error(`${info.file.name} file upload failed.`)
        setIsLoading(false)
      }
    },
    showUploadList: false,
  }

  return (
    <>
      <Spin spinning={isLoading} tip="Loading...">
        <PageHeader
          ghost={false}
          title={name}
          extra={(
            <Row gutter={[16]}>
              <Col>
                <Upload {...props}>
                  <Button icon={<UploadOutlined />} type="primary">Upload</Button>
                </Upload>
              </Col>
              <Col>
                <Button icon={<DownloadOutlined />} onClick={() => DownloadArticleStandard()}>Download</Button>
              </Col>
            </Row>
          )}
        >
          <Divider />
          <Table dataSource={articleList} size="small">
            <Column title="Article Standard" dataIndex="articleNo" key="articleNo" width={150} />
            <Column title="Created At" dataIndex="createdAt" key="createdAt" width={50} render={(text) => format(new Date(text), 'dd/MM/yyyy HH:mm')} />
          </Table>
        </PageHeader>
      </Spin>
    </>

  )
}

export default ArticleStandard
